import { useQuery, useQueryClient } from '@tanstack/react-query';

import * as memberServices from 'services/members';

const getChildrenCompanyParamsKey = (params) => {
  return ['get-children-company', params];
};

const getChildrenCompanyAllKey = () => {
  return ['get-children-company'];
};

export const useGetChildrenCompany = ({
  memberId,
  pagination,
  ...otherOptions
} = {}) => {
  const queryClient = useQueryClient();

  const queries = useQuery({
    queryKey: getChildrenCompanyParamsKey({
      memberId: Number(memberId),
      ...pagination,
    }),
    queryFn: async () => {
      const response = await memberServices.getChildrenCompany({
        memberId,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });

      if (response?.isSuccess) {
        return response?.data;
      }
    },
    enabled: Boolean(memberId),
    retry: 1,
    ...otherOptions,
  });

  const invalidateChildrenCompany = () => {
    queryClient.invalidateQueries({
      queryKey: memberId
        ? getChildrenCompanyParamsKey({
            memberId: Number(memberId),
            ...pagination,
          })
        : getChildrenCompanyAllKey(),
    });
  };

  const { data, isLoading } = queries || {};

  return {
    childrenCompanyList: data?.data?.gridData ?? [],
    ...data?.data?.paging,
    isLoading,
    invalidateChildrenCompany,
  };
};
